// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","Header":"App_Header__TQGAd","HeadWrap":"App_HeadWrap__7l25f","HeadLine":"App_HeadLine__LluNI"};